/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CarveOut } from './CarveOut';
import {
    CarveOutFromJSON,
    CarveOutFromJSONTyped,
    CarveOutToJSON,
} from './CarveOut';

/**
 * 
 * @export
 * @interface CarveOutListResponse
 */
export interface CarveOutListResponse {
    /**
     * 
     * @type {Array<CarveOut>}
     * @memberof CarveOutListResponse
     */
    data: Array<CarveOut>;
    /**
     * Sum of cost_per_day across carve-outs currently selected for submission.
     * @type {number}
     * @memberof CarveOutListResponse
     */
    total_cost_per_day: number;
    /**
     * 
     * @type {number}
     * @memberof CarveOutListResponse
     */
    incomplete_count: number;
}

/**
 * Check if a given object implements the CarveOutListResponse interface.
 */
export function instanceOfCarveOutListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total_cost_per_day" in value;
    isInstance = isInstance && "incomplete_count" in value;

    return isInstance;
}

export function CarveOutListResponseFromJSON(json: any): CarveOutListResponse {
    return CarveOutListResponseFromJSONTyped(json, false);
}

export function CarveOutListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CarveOutFromJSON)),
        'total_cost_per_day': json['total_cost_per_day'],
        'incomplete_count': json['incomplete_count'],
    };
}

export function CarveOutListResponseToJSON(value?: CarveOutListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(CarveOutToJSON)),
        'total_cost_per_day': value.total_cost_per_day,
        'incomplete_count': value.incomplete_count,
    };
}

